'use strict';

(function () {
  'use strict';

  angular.module('msActivityServices').service('activityFlagSvc', activityFlagSvc);

  angular.module('msAssessment').service('activityFlagSvc', activityFlagSvc);

  activityFlagSvc.$inject = ['httpSvc'];

  /* @ngInject */
  function activityFlagSvc(httpSvc) {
    return {
      skip: skip
    };
    /**
     * Skip or hide an activity
     * @param  {Object} activity the activity to skip or hide
     * @param  {boolean} hide     True if we should hide this completely instead of just skipping
     */
    function skip(activity, hide, reason) {
      return httpSvc.post('/apiproxy/user/activities/flag', {
        activityId: activity.id,
        type: hide ? 'HIDDEN' : 'SKIPPED',
        reason: reason || null
      });
    }
  }
})();